import { Reducer } from 'redux';
import { RenewPasswordAction } from '../types/renewPassword-types';
import FLUX_RENEW_PASSWORD_CONSTANTS from '../constants/renewPassword-constants';

export interface RenewPasswordReducerState {
    loading: boolean,
    backTo?: string,
    error: string,
    isSend: boolean
}

const initialState : RenewPasswordReducerState = {
    loading: false,
    backTo: undefined,
    error: '',
    isSend: false
}

export const renewPasswordReducer: Reducer<RenewPasswordReducerState, RenewPasswordAction> = (state = initialState, action: any) => {

    switch (action.type) {
        case FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_BEGIN:
            return {
                loading: true,
                isSend: false,
                error:''
            }

        case FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_ERROR:
            return {
                loading:false,
                error: action.error.message,
                isSend: false
            }
        
        case FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_SUCCESS:
            return {
                loading: false,
                error:'',
                isSend: true
            }

        case FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_CLEAR:
            return {
                loading: false,
                isSend: action.payload,
                error:''
            }
    
        default:
            return state;
    }
}
